import staffCollegeLogo from 'assets/images/staff.png';
import { ADToBS } from 'components/ui/Datepicker/Datepickerutils';
import moment from 'moment';
import { backendURL } from 'redux/reducers/settings';
import './tms-certificate.css';

interface ISignatory {
  label?: string;
  detail?: { role?: string; signature?: string | null };
}

interface TmsCertificateProps {
  selectedData: any;
  traineeList: any[];
  organisedFor: string;
  leftSignatory: ISignatory | null;
  rightSignatory: ISignatory | null;
  courseCoordinator: ISignatory | null;
}

// 2083-05-16 -> 2083/05/16
const toBsSlash = (bs?: string, ad?: string) => {
  const date = bs || (ad ? ADToBS(moment(ad).format('YYYY-MM-DD')) : '');
  return date ? date.replace(/-/g, '/') : '';
};

const Signature = ({ signatory, title }: { signatory: ISignatory | null; title?: string }) => (
  <div className="tms-sig-block">
    <div className="tms-sig-image">
      {signatory?.detail?.signature && (
        <img src={backendURL + '/' + signatory.detail.signature} alt="signature" />
      )}
    </div>
    <p className="tms-sig-name">{signatory?.label || ''}</p>
    <p className="tms-sig-role">{title ?? signatory?.detail?.role ?? ''}</p>
  </div>
);

const TmsCertificate: React.FC<TmsCertificateProps> = ({
  selectedData,
  traineeList,
  organisedFor,
  leftSignatory,
  rightSignatory,
  courseCoordinator
}) => {
  const from = toBsSlash(selectedData?.start_date_bs, selectedData?.start_date);
  const to = toBsSlash(selectedData?.end_date_bs, selectedData?.end_date);
  const issueDate = to || toBsSlash(undefined, moment().format('YYYY-MM-DD'));
  const courses: any[] = selectedData?.training_details?.courses || [];

  return (
    <>
      {/* Front */}
      <div className="certificate-page-break">
        <div className="tms-cert-page">
          <div className="tms-cert-border">
            <div className="tms-cert-inner">
              <div className="tms-cert-header">
                <img src={staffCollegeLogo} alt="logo" className="tms-cert-logo" />
                <div className="tms-cert-header-text">
                  <h1>Nepal Administrative Staff College</h1>
                  <h2>Governance and Development Management Learning Group</h2>
                  <h3>Centre for Procurement Management</h3>
                  <p>Jawalakhel, Lalitpur, Nepal</p>
                </div>
              </div>

              <div className="tms-cert-body">
                <h1 className="tms-cert-title">CERTIFICATE</h1>
                <p className="tms-cert-mentioned">Mentioned as on Back</p>
                <p className="tms-cert-text">participated in</p>
                <h2 className="tms-cert-training">
                  {selectedData?.training_details?.training_name || 'Training Programme'}
                </h2>
                {organisedFor && <p className="tms-cert-text">{organisedFor}</p>}
                <p className="tms-cert-text">
                  from {from} to {to}.
                </p>
              </div>

              <div className="tms-cert-footer">
                <Signature signatory={leftSignatory} />
                <div>
                  <Signature signatory={rightSignatory} />
                  <p className="tms-cert-issue">Date of Issue: {issueDate}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Back */}
      <div className="certificate-page-break">
        <div className="tms-back-page">
          <div className="tms-back-content">
            <div className="tms-back-contents">
              <h4>Contents Covered in the Programme:</h4>
              <ul>
                {courses.map((course: any) => (
                  <li key={course.id}>{course.title}</li>
                ))}
              </ul>
            </div>

            <table className="tms-back-table">
              <thead>
                <tr>
                  <th style={{ width: '60px' }}>S.No.</th>
                  <th>Name of the Participants</th>
                  <th style={{ width: '100px' }}>Remarks</th>
                </tr>
              </thead>
              <tbody>
                {traineeList.map((item: any, index: number) => (
                  <tr key={item.id ?? index}>
                    <td className="text-center">{index + 1}</td>
                    <td>
                      {[item?.first_name, item?.middle_name, item?.last_name]
                        .filter(Boolean)
                        .join(' ')}
                    </td>
                    <td></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="tms-back-coordinator">
            <Signature signatory={courseCoordinator} title="Course Coordinator" />
          </div>
        </div>
      </div>
    </>
  );
};

export default TmsCertificate;
